import { ComponentType, SVGProps } from 'react';

import { IconButton } from '@mui/material';
import cx from 'clsx';

import styles from './CarouselButton.module.scss';

interface IconProps {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}

interface CarouselButtonProps {
  onClick?: () => void;
  icon: ComponentType<IconProps>;
  style?: string;
  disabled?: boolean;
  ariaLabel: string;
}

const CarouselButton = ({ onClick, style, icon: Icon, disabled, ariaLabel }: CarouselButtonProps) => (
  <IconButton
    classes={{ root: styles.root }}
    className={cx(styles.container, style)}
    disabled={disabled}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <Icon size={24} />
  </IconButton>
);

export default CarouselButton;
